const exactHindiTranslations = {
  "Academic Management": "अकादमिक मैनेजमेंट",
  "Academic Performance": "अकादमिक प्रदर्शन",
  "Academic Session": "अकादमिक सत्र",
  "Academic Sessions": "अकादमिक सत्र",
  "Account Holder Name": "खाता धारक का नाम",
  "Account Number": "खाता संख्या",
  "Action": "कार्रवाई",
  "Action Target": "कार्रवाई लक्ष्य",
  "Actions": "कार्रवाइयां",
  "Active": "सक्रिय",
  "Active Notice Version": "सक्रिय नोटिस संस्करण",
  "Active schools need onboarding": "सक्रिय स्कूलों को ऑनबोर्डिंग चाहिए",
  "Add": "जोड़ें",
  "ADD": "जोड़ें",
  "Add Class": "कक्षा जोड़ें",
  "Add Custom Field": "कस्टम फील्ड जोड़ें",
  "Add Discount Rule": "डिस्काउंट नियम जोड़ें",
  "Add New Staff": "नया स्टाफ जोड़ें",
  "Add New Student": "नया विद्यार्थी जोड़ें",
  "Add Subject": "विषय जोड़ें",
  "Add/Edit Syllabus": "सिलेबस जोड़ें/संपादित करें",
  "Address": "पता",
  "Admin": "एडमिन",
  "Admin Dashboard": "एडमिन डैशबोर्ड",
  "Admission Number": "प्रवेश संख्या",
  "Affiliation No.": "संबद्धता संख्या",
  "All": "सभी",
  "All Schools": "सभी स्कूल",
  "Amount": "राशि",
  "Annually": "वार्षिक",
  "Attendance": "अटेंडेंस",
  "Attendance Overview": "अटेंडेंस अवलोकन",
  "Audit Ready": "ऑडिट के लिए तैयार",
  "Audit trail of user actions in the system": "सिस्टम में यूजर कार्रवाइयों का ऑडिट ट्रेल",
  "Awaiting DPO action": "DPO कार्रवाई प्रतीक्षित",
  "Back": "वापस",
  "Bank Name": "बैंक का नाम",
  "Book a Demo Today": "आज डेमो बुक करें",
  "Bulk": "बल्क",
  "Bulk (multiple fee types)": "बल्क (कई फीस प्रकार)",
  "Business Name": "व्यवसाय का नाम",
  "Cancel": "रद्द करें",
  "Cash": "नकद",
  "Category": "श्रेणी",
  "Change Status": "स्थिति बदलें",
  "Chat": "चैट",
  "Children": "बच्चे",
  "Class": "कक्षा",
  "Class & Section": "कक्षा और सेक्शन",
  "Class Level Fee Structure": "कक्षा स्तर फीस संरचना",
  "Class Name": "कक्षा का नाम",
  "Class Name *": "कक्षा का नाम *",
  "Class Pilot to Start": "शुरू करने के लिए कक्षा पायलट",
  "Class Section": "कक्षा सेक्शन",
  "Class attendance saved": "कक्षा अटेंडेंस सेव हुई",
  "Classwise Status": "कक्षा-वार स्थिति",
  "Closed": "बंद",
  "Code": "कोड",
  "Collection": "कलेक्शन",
  "Complete Financial Control": "पूर्ण वित्तीय नियंत्रण",
  "Confirm Deletion": "डिलीट की पुष्टि करें",
  "Confirm Password": "पासवर्ड की पुष्टि करें",
  "Confirm Status Change": "स्थिति बदलाव की पुष्टि करें",
  "Contact": "संपर्क",
  "Contacted": "संपर्क किया गया",
  "Created": "बनाया गया",
  "Create Fee Template": "फीस टेम्पलेट बनाएं",
  "Create New Class": "नई कक्षा बनाएं",
  "Create/Edit Time Table": "टाइमटेबल बनाएं/संपादित करें",
  "Custom Amount *": "कस्टम राशि *",
  "Custom Message": "कस्टम संदेश",
  "DELETE": "डिलीट",
  "DPDP Compliance Overview": "DPDP कम्प्लायंस अवलोकन",
  "DSAR Inbox (Data Subject Access Requests)": "DSAR इनबॉक्स (डेटा विषय एक्सेस अनुरोध)",
  "DSARs Fulfilled": "पूर्ण हुए DSAR",
  "Daily": "दैनिक",
  "Data Retention Policies": "डेटा रिटेंशन नीतियां",
  "Date": "तारीख",
  "Date of Birth": "जन्म तिथि",
  "Day": "दिन",
  "Days Overdue": "ओवरड्यू दिन",
  "Default Amount": "डिफॉल्ट राशि",
  "Default Amount (₹)": "डिफॉल्ट राशि (₹)",
  "Delete": "डिलीट",
  "Delete Topic": "टॉपिक डिलीट करें",
  "Demo Details": "डेमो विवरण",
  "Description": "विवरण",
  "Description (optional)": "विवरण (वैकल्पिक)",
  "Designation Role *": "पद भूमिका *",
  "Dimensions": "डायमेंशन",
  "Discount Type": "डिस्काउंट प्रकार",
  "Discounts": "डिस्काउंट",
  "Document Placeholder": "डॉक्यूमेंट प्लेसहोल्डर",
  "Document Templates": "डॉक्यूमेंट टेम्पलेट",
  "Download": "डाउनलोड",
  "Download Records": "रिकॉर्ड डाउनलोड करें",
  "Draft": "ड्राफ्ट",
  "Due Date": "देय तिथि",
  "Edit": "संपादित करें",
  "Edit Existing Class": "मौजूदा कक्षा संपादित करें",
  "Edit Existing Students": "मौजूदा विद्यार्थी संपादित करें",
  "Email": "ईमेल",
  "Email (Username)": "ईमेल (यूजरनेम)",
  "End Time": "समाप्ति समय",
  "English": "अंग्रेजी",
  "Exceeded 90-day limit": "90-दिन सीमा पार",
  "Export": "एक्सपोर्ट",
  "Fee & Finance Management": "फीस और वित्त मैनेजमेंट",
  "Fee Frequency": "फीस आवृत्ति",
  "Fee Management": "फीस मैनेजमेंट",
  "Fee Structure": "फीस संरचना",
  "Fee Structure Management": "फीस संरचना मैनेजमेंट",
  "Fee Templates": "फीस टेम्पलेट",
  "Fee Type": "फीस प्रकार",
  "Fee Type *": "फीस प्रकार *",
  "Fee Visibility": "फीस दृश्यता",
  "Fees": "फीस",
  "Female": "महिला",
  "Field Name": "फील्ड का नाम",
  "Filter": "फिल्टर",
  "Filter by status": "स्थिति से फिल्टर करें",
  "Final Notice": "अंतिम नोटिस",
  "Financial Aid": "वित्तीय सहायता",
  "Fixed Amount (₹)": "निश्चित राशि (₹)",
  "Formula": "फॉर्मूला",
  "Formula Editor": "फॉर्मूला एडिटर",
  "Frequency": "आवृत्ति",
  "Full Name": "पूरा नाम",
  "Gender": "लिंग",
  "Gender *": "लिंग *",
  "Gentle Reminder": "सौम्य रिमाइंडर",
  "Given By": "दिया गया",
  "Grace Period (days)": "ग्रेस अवधि (दिन)",
  "Grade": "ग्रेड",
  "Granted Purposes": "स्वीकृत उद्देश्य",
  "Hash": "हैश",
  "Hindi": "हिंदी",
  "Homework": "होमवर्क",
  "Homework and Academic Report": "होमवर्क और अकादमिक रिपोर्ट",
  "IFSC Code": "IFSC कोड",
  "Import": "इम्पोर्ट",
  "Incomplete Information": "अधूरी जानकारी",
  "Individual Student Fees": "व्यक्तिगत विद्यार्थी फीस",
  "Inactive": "निष्क्रिय",
  "Insert a field path at cursor position": "कर्सर स्थान पर फील्ड पाथ डालें",
  "Institution": "संस्थान",
  "Last Reminder": "अंतिम रिमाइंडर",
  "Linked Account ID": "लिंक्ड अकाउंट ID",
  "Live Product": "लाइव प्रोडक्ट",
  "Load from Fee Template": "फीस टेम्पलेट से लोड करें",
  "Loading": "लोड हो रहा है",
  "Loading inquiries…": "पूछताछ लोड हो रही है…",
  "Loading schools…": "स्कूल लोड हो रहे हैं…",
  "Locked": "लॉक्ड",
  "Logout": "लॉगआउट",
  "Male": "पुरुष",
  "Manage Certificates": "सर्टिफिकेट संभालें",
  "Manual Errors": "मैनुअल त्रुटियां",
  "Map placeholders in your Word document to student data fields": "Word दस्तावेज के प्लेसहोल्डर को विद्यार्थी डेटा फील्ड से मैप करें",
  "Medium": "माध्यम",
  "Merit": "मेरिट",
  "Message": "संदेश",
  "Monthly": "मासिक",
  "Name": "नाम",
  "NEP Holistic Progress Cards": "NEP समग्र प्रगति कार्ड",
  "N/A": "लागू नहीं",
  "New": "नया",
  "New Fee Type Name": "नया फीस प्रकार नाम",
  "New Subject Name": "नया विषय नाम",
  "No Administrative Functions Available": "कोई प्रशासनिक फंक्शन उपलब्ध नहीं",
  "No fee templates found. Create templates in the": "कोई फीस टेम्पलेट नहीं मिला। पहले",
  "No records found": "कोई रिकॉर्ड नहीं मिला",
  "No requests found": "कोई अनुरोध नहीं मिला",
  "No schools found": "कोई स्कूल नहीं मिला",
  "None": "कोई नहीं",
  "Not onboarded": "ऑनबोर्ड नहीं",
  "Not set": "सेट नहीं",
  "Notice Board": "नोटिस बोर्ड",
  "Notice Ver.": "नोटिस संस्करण",
  "Ongoing": "जारी",
  "One-time": "एक बार",
  "Open DSARs": "खुले DSAR",
  "Opened": "खोला गया",
  "Other": "अन्य",
  "Overdue Amount": "ओवरड्यू राशि",
  "Parent": "अभिभावक",
  "Parent Academic Report": "अभिभावक अकादमिक रिपोर्ट",
  "Parent Communication": "अभिभावक संवाद",
  "Parent Name": "अभिभावक का नाम",
  "Password": "पासवर्ड",
  "Payment History": "भुगतान इतिहास",
  "Payment Routing": "भुगतान रूटिंग",
  "Pending": "लंबित",
  "Percentage (%)": "प्रतिशत (%)",
  "Phone": "फोन",
  "Phone Number": "फोन नंबर",
  "Placeholder Prefix (optional)": "प्लेसहोल्डर प्रीफिक्स (वैकल्पिक)",
  "Present": "उपस्थित",
  "Present marked": "उपस्थित मार्क किया गया",
  "Principal": "प्रिंसिपल",
  "Principal Dashboard": "प्रिंसिपल डैशबोर्ड",
  "Product Proof": "प्रोडक्ट प्रमाण",
  "Qualification": "योग्यता",
  "Quarterly": "त्रैमासिक",
  "Refresh data": "डेटा रीफ्रेश करें",
  "Refresh inquiries": "पूछताछ रीफ्रेश करें",
  "Relation": "संबंध",
  "Reminder Type": "रिमाइंडर प्रकार",
  "Reports": "रिपोर्ट",
  "Residential Address": "निवास पता",
  "Restart": "फिर शुरू करें",
  "Retry": "फिर कोशिश करें",
  "Role": "भूमिका",
  "Roll Number": "रोल नंबर",
  "Room": "कक्ष",
  "Routing": "रूटिंग",
  "Routing active": "रूटिंग सक्रिय",
  "Rule Type": "नियम प्रकार",
  "SLA Breached": "SLA उल्लंघन",
  "SLA Due": "SLA देय",
  "Salary & Payroll": "वेतन और पेरोल",
  "Save": "सेव",
  "Schedule Date": "शेड्यूल तारीख",
  "School": "स्कूल",
  "School Management": "स्कूल मैनेजमेंट",
  "School Status": "स्कूल स्थिति",
  "School will be able to access SpellStudy.": "स्कूल SpellStudy एक्सेस कर सकेगा।",
  "School will lose access to the platform.": "स्कूल प्लेटफॉर्म का एक्सेस खो देगा।",
  "Schools Onboarded": "ऑनबोर्डेड स्कूल",
  "Score Field": "स्कोर फील्ड",
  "Search Students": "विद्यार्थी खोजें",
  "Search by name or roll number": "नाम या रोल नंबर से खोजें",
  "Search fields...": "फील्ड खोजें...",
  "Section": "सेक्शन",
  "Security": "सुरक्षा",
  "Select": "चुनें",
  "Select All": "सभी चुनें",
  "Select Class": "कक्षा चुनें",
  "Select Class *": "कक्षा चुनें *",
  "Select Education Board": "शिक्षा बोर्ड चुनें",
  "Select Exam": "परीक्षा चुनें",
  "Select Field": "फील्ड चुनें",
  "Select Section": "सेक्शन चुनें",
  "Select Section *": "सेक्शन चुनें *",
  "Send Fee Reminders": "फीस रिमाइंडर भेजें",
  "Send Now": "अभी भेजें",
  "Sent": "भेजा गया",
  "Severity": "गंभीरता",
  "Sibling": "भाई-बहन",
  "Staff": "स्टाफ",
  "Staff Bio & Records": "स्टाफ बायो और रिकॉर्ड",
  "Start Date": "शुरू तारीख",
  "Start Time": "शुरू समय",
  "Status": "स्थिति",
  "Student": "विद्यार्थी",
  "Student Field": "विद्यार्थी फील्ड",
  "Student ID": "विद्यार्थी ID",
  "Student Improvement": "विद्यार्थी सुधार",
  "Student Name": "विद्यार्थी का नाम",
  "Student records": "विद्यार्थी रिकॉर्ड",
  "Students": "विद्यार्थी",
  "Subject": "विषय",
  "Submit": "जमा करें",
  "Syllabus": "सिलेबस",
  "Teacher": "शिक्षक",
  "Teacher Attendance": "शिक्षक अटेंडेंस",
  "Teacher Class Tools": "शिक्षक कक्षा टूल",
  "Teacher Dashboard": "शिक्षक डैशबोर्ड",
  "Teacher Options": "शिक्षक विकल्प",
  "Teacher workflow": "शिक्षक वर्कफ्लो",
  "Term": "टर्म",
  "This academic year": "इस अकादमिक वर्ष",
  "Topic Description": "टॉपिक विवरण",
  "Topic Title": "टॉपिक शीर्षक",
  "Total": "कुल",
  "Total Cards": "कुल कार्ड",
  "Tuition": "ट्यूशन",
  "Type": "प्रकार",
  "UPDATE": "अपडेट",
  "UPI ID": "UPI ID",
  "Upcoming Exams": "आगामी परीक्षाएं",
  "Update": "अपडेट",
  "Urgent Reminder": "तत्काल रिमाइंडर",
  "User Activity Logs": "यूजर गतिविधि लॉग",
  "UserManagement": "यूजर मैनेजमेंट",
  "Voiceover": "वॉयसओवर",
  "Welcome Dashboard": "स्वागत डैशबोर्ड",
  "Year": "वर्ष",
  "Year of Passing": "उत्तीर्ण वर्ष",
  "You don't have permission to access any administrative functions. Contact your administrator to request access.": "आपके पास किसी भी प्रशासनिक फंक्शन को खोलने की अनुमति नहीं है। एक्सेस के लिए अपने एडमिनिस्ट्रेटर से संपर्क करें।",
  "Your effective role is now automatically set to your highest authority level.": "आपकी प्रभावी भूमिका अब अपने-आप आपके सबसे उच्च अधिकार स्तर पर सेट हो गई है।",
  "early_payment": "अर्ली पेमेंट",
  "financial_aid": "वित्तीय सहायता",
  "remove subject parameter": "विषय पैरामीटर हटाएं",
};

const patterns = [
  [/^Class (\d+)$/, "कक्षा $1"],
  [/^(\d+) more\.\.\.$/, "$1 और..."],
  [/^Min Score \(≥\)$/, "न्यूनतम स्कोर (≥)"],
  [/^e\.g\. (.+)$/i, "उदा. $1"],
];

export const translateLiteral = (value, language) => {
  if (language !== "hi" || typeof value !== "string") return value;
  const normalizedValue = value.replace(/\s+/g, " ").trim();
  if (!normalizedValue) return value;

  const exactTranslation = exactHindiTranslations[normalizedValue];
  if (exactTranslation) return exactTranslation;

  for (const [pattern, replacement] of patterns) {
    if (pattern.test(normalizedValue)) {
      return normalizedValue.replace(pattern, replacement);
    }
  }

  return value;
};

export const hasLiteralTranslation = (value) =>
  typeof value === "string" &&
  (Boolean(exactHindiTranslations[value.replace(/\s+/g, " ").trim()]) ||
    patterns.some(([pattern]) => pattern.test(value.replace(/\s+/g, " ").trim())));
